export default {
  ok: 'OK',
  yes: 'Ja',
  save: 'Gem',
  unsave: 'Gem ikke',
  cancel: 'Annuller',
  more: 'Flere',
  delete: 'Slet',
  edit: 'Rediger',
  close: 'Luk',
  move: 'Flyt',
  export_pdf: 'Eksporter som pdf',
  journalize_manually: 'Journaliseres manuelt',
  journalized_manually: 'Journaliseret manuelt',
  resend: 'gensend',
  clear_all: 'Ryd alt',
  clear_selected: 'Ryd valgte',
  regret: 'Fortryd',
  continue: 'Fortsæt',
  associate: 'Tilknyt',
  filter: 'Filtrér',
  rename: 'Omdøb',
  apply: 'Ansøg',
  register: 'Tilmeld',
  unregister: 'Fjern tilmeldte',
  unregister_blocker: 'Fjern blokering',
  download: 'Download',
  add_sleep_time: 'Tilføj sovetid',
  delete_sleep_time: 'Slet sovetid',
  open_in_new_tab: 'Åbn i ny fane',
  search: 'Søg',
  add: 'Tilføj',
};
